import ChangePassWord from '../../../components/organisms/admin/account/ChangePassword'

type Props = {}

const ChangePasswordPage = (props: Props) => {
  return (
    <ChangePassWord />
  )
}

export default ChangePasswordPage